<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box "
    :mask-closable="false"
    :footer="null"
    :closable="false"
  >
    <div
      class="dialog-tip-box dialog-tip-blue"
    >
      <i class="icon iconfont iconicon-test70" />
      <h2>{{ $t('message["1152"]') }}</h2>
      <div class="d-tip-con">
        {{ duration }}{{ $t('message["644"]') }}
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  components: {
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false,
      typeError: 0,
      duration: 5
    }
  },
  computed: {
    ...mapState('organization/cloud', ['userid'])
  },
  watch: {
    TipDialogVisible (val) {
      const interval = setInterval(() => {
        if (this.duration > 1) {
          this.duration--
        } else {
          location.reload()
          clearInterval(interval)
        }
      }, 1000)
    }
  },
  created () {
  },
  methods: {
    ...mapActions('account/modify', ['mergeUser']),
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-tip-blue {
  .icon-tips-info1 {
    color: #4a90e2;
  }
}
</style>
